import { mapLocation } from '../../../config/mapLocation';
import { contactInfo } from '../../../config/contactInfo';
import ScheduleButton from '../../ScheduleButton/scheduleButton';

const fullAddress = `${contactInfo.addressLine1}, ${contactInfo.addressLine2}`;
const queryFallback = encodeURIComponent(fullAddress);
const queryByPlaceId = mapLocation.placeId
  ? encodeURIComponent(`place_id:${mapLocation.placeId}`)
  : '';
const mapQuery = queryByPlaceId || queryFallback;
const mapEmbedUrl = `https://www.google.com/maps?q=${mapQuery}&z=${mapLocation.zoom}&hl=pt-BR&output=embed`;

interface LocationContentProps {
  /** Se true, exibe o título "Nome | Especialidade" (Location); se false, oculta (Home) */
  asPageTitle?: boolean;
}

function LocationContent({ asPageTitle = false }: LocationContentProps) {
  const phoneLinks = contactInfo.phones.map((number) => {
    const digits = number.replace(/\D/g, '');
    return { display: number, href: `tel:+55${digits}` };
  });

  return (
    <>
      <section className="contact-block">
        {asPageTitle && (
          <h1 className="contact-block-title">
            {contactInfo.name} | {contactInfo.specialty}
          </h1>
        )}
        <p className="contact-block-observation">
          <strong>{contactInfo.observation}</strong>
        </p>
        <p className="contact-block-address">
          {contactInfo.addressLine1}
          <br />
          {contactInfo.addressLine2}
        </p>
        <p className="contact-block-phones">
          Telefone{' '}
          {phoneLinks.map((phone, i) => (
            <span key={i}>
              <a href={phone.href} className="contact-block-link">
                {phone.display}
              </a>
              {i < phoneLinks.length - 1 ? ' | ' : ''}
            </span>
          ))}
        </p>
        <p className="contact-block-email">
          E-mail{' '}
          <a href={`mailto:${contactInfo.email}`} className="contact-block-link">
            {contactInfo.email}
          </a>
        </p>
        {asPageTitle && (
          <p className="contact-block-button">
            <ScheduleButton isBanner={false} />
          </p>
        )}
      </section>
      <div className="map-widget">
        <div className="map-container">
          <iframe
            title={`Mapa - ${mapLocation.label}`}
            src={mapEmbedUrl}
            className="map-iframe"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </>
  );
}

export default LocationContent;
